import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useMediaQuery } from "@mui/material";
import SectionContainer from "./SectionContainer";
import CustomModal from "../../../../common/Modal";
import Button from "../../../../sub-component/Button";
import Search from "../../../../sub-component/Search";
import { PathName } from "../../../../../utils/routes";
import { TestType } from "../../../../../utils/Constants";
import SearchAndFilterTests from "./SearchAndFilterTests";
import { secondsToDhms } from "../../../../../utils/utilities";
import { skill_test_data } from "../../../../../utils/assessmentQuestionsJSON";
import { ReactComponent as EyeIcon } from "../../../../../assets/icons/Views/dashboard/assessments/eye.svg";
import { ReactComponent as CrossIcon } from "../../../../../assets/icons/Views/dashboard/assessments/x.svg";
import { ReactComponent as AddIcon } from "../../../../../assets/icons/Views/dashboard/assessments/plus.svg";
import { ReactComponent as InfoIcon } from "../../../../../assets/icons/Views/dashboard/assessments/info.svg";
import { ReactComponent as ClockIcon } from "../../../../../assets/icons/Views/dashboard/create-assessment/clock.svg";
import { ReactComponent as WarningIcon } from "../../../../../assets/icons/Views/dashboard/assessments/alert-circle.svg";
import { ReactComponent as LeftArrowIcon } from "../../../../../assets/icons/Views/dashboard/create-assessment/Vector.svg";
import { ReactComponent as PrimaryCrossIcon } from "../../../../../assets/icons/Views/dashboard/assessments/primary-x.svg";
import { ReactComponent as RightArrowIcon } from "../../../../../assets/icons/Views/dashboard/create-assessment/right-arrow.svg";

export default function CodingTest(props) {
  const { isEditAssessment, sectionDetails, codingTestPacks } = props;

  const isOnTabletScreen = useMediaQuery(
    "(min-width:768px) and (max-width:1279px)",
  );
  const isOnWebScreen = useMediaQuery("(min-width:1280px)");
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");

  const limit = 3;
  const overFlowRef = useRef(null);
  const [start, setStart] = useState(0);
  const [Finish, setFinish] = useState(9);
  const [selectedData, setSelectedData] = useState(
    sectionDetails?.test?.questions,
  );
  const [dataList, setDataList] = useState(codingTestPacks);
  const [selectedTestInfo, setSelectedTestInfo] = useState({
    test: null,
    openModal: false,
  });
  const [isCodindTestOverFlow, setIsCodindTestOverFlow] = useState(false);
  const [filteredDataList, setFilteredDataList] = useState(codingTestPacks);

  useEffect(() => {
    if (overFlowRef?.current) {
      const divElement = overFlowRef.current;

      if (
        divElement.scrollWidth > divElement.clientWidth ||
        divElement.scrollHeight > divElement.clientHeight
      ) {
        setIsCodindTestOverFlow(true);
      } else {
        setIsCodindTestOverFlow(false);
      }
    }
  }, [selectedData]);

  const scrollLeft = () => {
    if (overFlowRef.current) {
      overFlowRef.current.scrollBy({
        left: -260, // Adjust the scroll amount as per your requirement
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (overFlowRef.current) {
      overFlowRef.current.scrollBy({
        left: 260, // Adjust the scroll amount as per your requirement
        behavior: "smooth",
      });
    }
  };

  // useEffect(() => {

  // }, [overFlowRef.current.])

  const showPreviewPage = (id) => {
    const url = `${PathName.TESTPACK_PREVIEW_QUESTIONS}?test_id=${id}`;
    window.open(url, "_blank");
  };

  const filtersForCodingTest = [
    {
      type: "radio",
      filter_for: "supported_coding_languages",
      title: null,
      options: [
        { text: "Language Specific", id: "language-specific" },
        { text: "Language Agnostic", id: "language-agnostic" },
      ],
    },
    {
      type: "check-box",
      title: "Choose Difficulty Level",
      filter_for: "difficulty",
      options: [
        { text: "Entry Level", id: "entry-level" },
        { text: "Intermediate Level", id: "intermediate" },
        { text: "Advanced Level", id: "advanced" },
      ],
    },
  ];

  const SkillButtonComp = (props) => {
    const { checked, preview_questions } = props;
    let _lang = "";

    props?.supported_coding_languages &&
      props.supported_coding_languages.forEach((lang, index) => {
        if (
          index != 0 &&
          index === props.supported_coding_languages.length - 1
        ) {
          _lang = _lang + " and ";
        } else {
          if (
            index < props.supported_coding_languages.length - 1 &&
            index !== 0 &&
            props.supported_coding_languages.length > 2
          ) {
            _lang = _lang + ", ";
          } else {
            _lang = _lang + "";
          }
        }
        _lang = _lang + lang.language_name;
      });
    const supported_coding_languages =
      "Can be solved in " + _lang + " languages";
    return (
      <div
        className={`d-flex flex-column justify-content-between${props.checked
          ? " selected-coding-test-box-container "
          : " unselect-coding-test-box-container "
          } coding-test-box-container pointer`}
        style={{ ...props.style }}
      >
        <div className="d-flex flex-column w-100 position-relative">
          {!checked && (
            <>
              <div
                className="d-flex justify-content-between"
                style={{ gap: "13.33px" }}
              >
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{
                    padding: "6px 20px",
                    background: "#7C21FF",
                    borderRadius: "24px",
                    width: "110px",
                  }}
                >
                  <span className="body-3 white">Most Popular</span>
                </div>
                {!isOnTabletScreen && (
                  <div className="d-flex align-items-center justify-content-center">
                    <ClockIcon style={{ width: "16px", height: "16px" }} />
                    <span
                      className="body-2 dark-50"
                      style={{ marginLeft: "4px" }}
                    >
                      {secondsToDhms(props?.duration || "-")}
                    </span>
                  </div>
                )}
              </div>
              {isOnTabletScreen && (
                <div
                  className="d-flex align-items-center"
                  style={{ marginTop: "6px" }}
                >
                  <ClockIcon style={{ width: "16px", height: "16px" }} />
                  <span
                    className="body-2 dark-50"
                    style={{ marginLeft: "4px" }}
                  >
                    {secondsToDhms(props?.duration || "-")}
                  </span>
                </div>
              )}
            </>
          )}
          <div
            className="d-flex justify-content-between "
            style={{ width: "100%", marginTop: "16px" }}
          >
            <div className=" d-flex">
              {!checked && (
                <div className="d-flex align-items-center">
                  <div style={{ height: "27px", width: "27px" }}>
                    <img
                      src={props.icon}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                </div>
              )}

              <div
                className="d-flex flex-column w-100"
                style={{ marginLeft: checked ? "0px" : "10px" }}
              >
                <div className="w-100 d-flex align-items-center justify-content-between">
                  <div
                    className="d-flex"
                    style={{ width: "75%", maxHeight: "48px" }}
                  >
                    <span
                      title={
                        checked
                          ? `${props.title} - ${props?.supported_coding_languages?.length > 1
                            ? supported_coding_languages
                            : props.difficulty
                          } `
                          : props.title
                      }
                      className="body-1 dark-100 coding-test-box-container-text-overflow text-overflow"
                      style={{
                        textAlign: "start",
                        marginRight: checked ? "10px" : "",
                        marginTop: checked ? "-12px" : "",
                      }}
                    >
                      {checked
                        ? `${props.title} - ${props?.supported_coding_languages?.length > 1
                          ? supported_coding_languages
                          : props.difficulty
                        } `
                        : props.title}
                    </span>
                  </div>
                </div>
                {props?.supported_coding_languages?.length === 1 &&
                  !checked && (
                    <span
                      className="body-2 dark-50 text-start"
                      style={{
                        marginTop: "4px",
                      }}
                    >
                      {props.difficulty || "N/A"}
                    </span>
                  )}

                {props?.supported_coding_languages?.length > 1 && !checked && (
                  <span
                    className="body-2 dark-50 coding-test-box-container-text-overflow"
                    style={{
                      marginTop: "4px",
                    }}
                    title={supported_coding_languages}
                  >
                    {supported_coding_languages}
                  </span>
                )}
              </div>
            </div>
            {preview_questions && (
              <EyeIcon
                className="svg"
                style={{
                  width: "16px",
                  height: "16px",
                  position: "absolute",
                  right: "22px",
                }}
                onClick={props.showPreviewPage}
              />
            )}
            <InfoIcon
              className="svg"
              style={{
                width: "14px",
                height: "14px",
                position: "absolute",
                right: "0px",
              }}
              onClick={
                isOnMobileScreen ? props.showInfoPage : props.showInfoModal
              }
            />
          </div>
          {checked && (
            <div
              className="d-flex align-items-center"
              style={{ marginTop: "6px" }}
            >
              <ClockIcon style={{ width: "16px", height: "16px" }} />
              <span className="body-4 black-500" style={{ marginLeft: "4px" }}>
                {secondsToDhms(props?.duration || "-")}
              </span>
            </div>
          )}
        </div>
        <Button
          onClick={() => {
            props.onClick();
          }}
          className={`${checked
            ? "selected-coding-test-box-btn"
            : !checked && selectedData.length === limit
              ? "disabled-coding-test-box-btn"
              : "coding-test-box-btn"
            }`}
          style={{
            height: "32px",
            marginBottom: checked && "8px",
            opacity: isEditAssessment ? "0.3" : "1",
            background: "#121216",
          }}
          btn="ragular-btn"
          disabled={
            (!checked && selectedData.length === limit) || isEditAssessment
          }
          varrient="secondary-btn"
          size="sm"
          title={checked ? (isEditAssessment ? "Added" : "Remove") : "Add"}
          preIcon={
            isEditAssessment ? (
              <></>
            ) : checked ? (
              <CrossIcon style={{ width: "15.4px" }} />
            ) : (
              <AddIcon style={{ width: "15.4px" }} />
            )
          }
        />
      </div>
    );
  };

  const DataListMemo = useMemo(() => {
    return (
      <>
        {filteredDataList?.map((data, index) => {
          const isSelected = selectedData.find((d) => d.id === data.id);
          const preview_questions = data?.preview_questions;
          return (
            <Fragment key={index}>
              {!isSelected && (
                <SkillButtonComp
                  title={data}
                  style={{ marginTop: "0px" }}
                  {...data}
                  checked={false}
                  onClick={() => {
                    setSelectedData([...selectedData, data]);
                    props.getUpdatedSectionLocalData({
                      ...sectionDetails,
                      test: {
                        ...sectionDetails.test,
                        questions: [...selectedData, data],
                      },
                    });
                    props.onCheckSectionDataConfermation({
                      ...sectionDetails,
                      test: {
                        ...sectionDetails.test,
                        questions: [...selectedData, data],
                      },
                    });
                  }}
                  preview_questions={preview_questions}
                  showPreviewPage={() => showPreviewPage(data.id)}
                  showInfoPage={() => {
                    setSelectedTestInfo({
                      openModal: true,
                      test: data,
                      isItemAdded: selectedData.find((d) => d.id === data?.id),
                    });
                    props.showInfoPage({
                      openModal: true,
                      test: data,
                      isItemAdded: selectedData.find((d) => d.id === data?.id),
                    });
                  }}
                  showInfoModal={() => {
                    setSelectedTestInfo({ openModal: true, test: data });
                  }}
                />
              )}
            </Fragment>
          );
        })}
      </>
    );
  }, [selectedData, start, Finish, filteredDataList]);

  const SelectedDataListMemo = useMemo(() => {
    return (
      <div className="d-flex align-items-center position-relative w-100">
        {isCodindTestOverFlow && (
          <div
            className="selected-test-overflow-arrow-left pointer"
            style={{ position: "absolute", left: "0px", zIndex: "1" }}
            onClick={scrollLeft}
          >
            <LeftArrowIcon style={{ width: "32px", height: "32px" }} />
          </div>
        )}
        <div
          ref={overFlowRef}
          className="searched-filtered-ct-container hide-scrollbar"
          style={{ padding: isCodindTestOverFlow ? "0px 55px" : "0px 0px" }}
        >
          {selectedData?.map((data, index) => {
            return (
              <>
                {
                  <div className="searched-filtered-ct">
                    <SkillButtonComp
                      title={data}
                      style={{ marginTop: "8px", height: "100%" }}
                      {...data}
                      checked={true}
                      onClick={() => {
                        const tempArr = selectedData;
                        tempArr.splice(selectedData.indexOf(data), 1);
                        setSelectedData([...tempArr]);
                        props.getUpdatedSectionLocalData({
                          ...sectionDetails,
                          test: {
                            ...sectionDetails.test,
                            questions: [...tempArr],
                          },
                        });
                        props.onCheckSectionDataConfermation({
                          ...sectionDetails,
                          test: {
                            ...sectionDetails.test,
                            questions: [...tempArr],
                          },
                        });
                      }}
                      showPreviewPage={() => showPreviewPage(data.id)}
                      showInfoPage={() => {
                        setSelectedTestInfo({
                          openModal: true,
                          test: data,
                          isItemAdded: selectedData.find(
                            (d) => d.id === data?.id,
                          ),
                        });
                        props.showInfoPage({
                          openModal: true,
                          test: data,
                          isItemAdded: selectedData.find(
                            (d) => d.id === data?.id,
                          ),
                        });
                      }}
                      showInfoModal={() => {
                        setSelectedTestInfo({ openModal: true, test: data });
                      }}
                    />
                  </div>
                }
              </>
            );
          })}
        </div>
        {isCodindTestOverFlow && (
          <div
            className="selected-test-overflow-arrow-left pointer"
            style={{
              position: "absolute",
              right: "-2px",
              zIndex: "1",
              transform: "rotate(180deg)",
            }}
            onClick={scrollRight}
          >
            <LeftArrowIcon style={{ width: "32px", height: "32px" }} />
          </div>
        )}
      </div>
    );
  }, [selectedData, start, Finish, filteredDataList]);

  const onConfirm = () => {
    props.onConfirm({
      ...sectionDetails,
      test: { ...sectionDetails.test, questions: selectedData },
    });
  };

  const onCancel = () => {
    props.onCancel({
      ...sectionDetails,
      test: { ...sectionDetails.test, questions: selectedData },
    });
  };

  useEffect(() => {
    if (props.error) {
      props.setCheckValidation(true);
    }
  }, [selectedData]);

  useEffect(() => {
    if (props?.resetAssessmentCreationSection) {
      setSelectedData(sectionDetails?.test?.questions);
      props?.getToKnowIFStateUpdated("coding_test_updated", true);
    }
  }, [props?.resetAssessmentCreationSection]);

  return (
    <>
      <CustomModal
        open={selectedTestInfo.openModal && !isOnMobileScreen}
        test={selectedTestInfo.test}
        handleCloseModal={() => {
          setSelectedTestInfo({ test: null, openModal: false });
        }}
        isItemAdded={selectedData.find(
          (d) => d.id === selectedTestInfo?.test?.id,
        )}
        disabled={
          (!selectedData.find((d) => d.id === selectedTestInfo?.test?.id) &&
            selectedData.length === limit) ||
          isEditAssessment
        }
        isEditAssessment={isEditAssessment}
        preview_questions={selectedTestInfo?.test?.preview_questions}
        showPreviewPage={() => showPreviewPage(selectedTestInfo?.test?.id)}
        varrient="view-test-details"
        add_remove_assessment={() => {
          if (selectedData.find((d) => d.id === selectedTestInfo?.test?.id)) {
            const tempArr = selectedData;
            tempArr.splice(selectedData.indexOf(selectedTestInfo?.test), 1);
            setSelectedData([...tempArr]);
            props.getUpdatedSectionLocalData({
              ...sectionDetails,
              test: { ...sectionDetails.test, questions: [...tempArr] },
            });
            props.onCheckSectionDataConfermation({
              ...sectionDetails,
              test: { ...sectionDetails.test, questions: [...tempArr] },
            });
          } else {
            setSelectedData([...selectedData, selectedTestInfo?.test]);
            props.getUpdatedSectionLocalData({
              ...sectionDetails,
              test: {
                ...sectionDetails.test,
                questions: [...selectedData, selectedTestInfo?.test],
              },
            });
            props.onCheckSectionDataConfermation({
              ...sectionDetails,
              test: {
                ...sectionDetails.test,
                questions: [...selectedData, selectedTestInfo?.test],
              },
            });
          }
        }}
      />
      <SectionContainer
        title={"Coding Tests"}
        enableDuration
        description={
          "Your candidate will solve coding problems in the respective programming languages."
        }
        onRemoveSection={() => {
          props.onRemoveSection();
        }}
        error={props.error}
        onConfirm={onConfirm}
        onCancel={onCancel}
        duration={selectedData?.reduce(
          (preValue, data) => preValue + Math.floor(data.duration / 60),
          0,
        )}
        isEditAssessment={isEditAssessment}
      >
        {isEditAssessment ? (
          <div
            className="w-100 d-flex flex-column align-items-start"
            style={{ marginTop: "8px" }}
          >
            {SelectedDataListMemo}
          </div>
        ) : (
          <div
            className="w-100 d-flex flex-column align-items-start"
            style={{ marginTop: "8px" }}
          >
            <SearchAndFilterTests
              dataList={dataList
                .map((test, _) => {
                  if (
                    selectedData.filter((selctedFilter) => {
                      return selctedFilter.id === test.id;
                    }).length === 0
                  ) {
                    return test;
                  }
                })
                .filter((_d) => {
                  return _d !== undefined;
                })}
              applyFuzzyFilter
              testPackType={TestType.CODING_TEST}
              onSearchParams={{
                searchOnAttributes: [
                  "title",
                  "supported_coding_languages_text",
                  "difficulty",
                ],
                placeholder: `${isOnWebScreen
                  ? "Search language, keyword, problem..."
                  : "Search..."
                  }`,
              }}
              filterOptions={filtersForCodingTest}
              getResultentData={(data) => {
                setFilteredDataList(data);
              }}
              onSelection={(data) => {
                if (
                  selectedData.filter((d) => d.id === data?.id).length === 0 &&
                  selectedData.length < limit
                ) {
                  setSelectedData([...selectedData, data]);
                  props.getUpdatedSectionLocalData({
                    ...sectionDetails,
                    test: {
                      ...sectionDetails.test,
                      questions: [...selectedData, data],
                    },
                  });
                  props.onCheckSectionDataConfermation({
                    ...sectionDetails,
                    test: {
                      ...sectionDetails.test,
                      questions: [...selectedData, data],
                    },
                  });
                }
              }}
            >
              {SelectedDataListMemo}
            </SearchAndFilterTests>
            {props.error && (
              <div className="error-box mt-2 w-100 mb-2">
                <WarningIcon
                  style={{ width: "24px", height: "24px", marginRight: "12px" }}
                />
                <span className="body-3 text-danger">
                  At least one Coding Test should be selected!
                </span>
              </div>
            )}
            {selectedData.length === limit && (
              <div className="error-box mt-2 w-100 mb-2">
                <WarningIcon
                  style={{ width: "24px", height: "24px", marginRight: "12px" }}
                />
                <span className="body-3 text-danger">
                  You can only add 3 Coding Testpack at a time!
                </span>
              </div>
            )}
            <div className="coding-test-container">{DataListMemo}</div>
          </div>
        )}
      </SectionContainer>
    </>
  );
}
